import { createReducer } from 'redux-create-reducer'
import { CAMPAIGN_SEARCH } from '@disco/constants/ActionTypes'
export type State = {
  q: string | null | undefined
}
const initialState: State = {
  q: null,
}
export const campaignSearchReducer = createReducer<State, any>(initialState, {
  [CAMPAIGN_SEARCH](state, action) {
    return { ...state, q: action.q }
  },
})
